import FooterLanguageSwitcher from './FooterLanguageSwitcher';

export default FooterLanguageSwitcher;